<!--
* @description  货物信息组件
* @fileName  origin
* @author userName
* @date 2024-01-04 17:05:57
!-->
<template>
	<div id="origin" v-clickoutside="closePanel" class="origin">
		<input :ref="`${searchKeysType}Input`" v-model="text" 
			:class="{
				'active-border': true,
				'input-error': inputErrorShow,
				'input-disabled': disabled
			}" 
			:placeholder="placeholderShow" 
			:style="{ width: width + 'px' }" 
			:disabled="disabled" 
			@focus="focusInput"
			@blur="blurInput" />
		<el-collapse-transition>
			<div v-if="panelShow" :class="{ 'by-panel': true }" @mouseenter="panelOpen = true"
				@mouseleave="panelOpen = false">
				<!-- <div class="load-title">
				  <span>┃</span>
				  <span>Where are you shipping? </span>
				</div> -->
				<div class="load-tab">
					<div :class="['tab-class', { active: selectNumber == 0 }]" @click="clickType(item, 0)">
						{{$t('home.eachItem')}}
					</div>
					<div :class="['tab-class', { active: selectNumber == 1 }]" @click="clickType(item, 1)">
						{{$t('home.eachTicket')}}
					</div>
				</div>
				<UnitType v-show="selectNumber == 0" ref="UnitType" @next="unitSuccess" />
				<TotalShipment v-show="selectNumber == 1" ref="TotalShipment" @next="totalSuccess" />
			</div>
		</el-collapse-transition>
	</div>
</template>

<script>
	import TotalShipment from './Calculate/totalShipment.vue';
	import UnitType from './Calculate/unitType.vue';
	export default {
		name: 'LoadComponent',
		components: {
			// 组件的引用
			TotalShipment,
			UnitType
		},
		props: {
			// 父辈向子辈传参
			// 禁用输入
			disabled: { type: Boolean, default: false },
			// 搜索关键词
			searchKeysType: { type: String, required: true, default: 'City' },
			width: { type: String, required: false, default: '200' },
			// 输入框默认提示
			// type: String
			placeholder: { required: false, default: '' }
		},
		data() {
			return {
				text: '', // 输入框显示文字
				panelShow: false,
				inputErrorShow: false,
				panelOpen: false,
				placeholderShow: '您要运送什么？', // 输入框默认显示提示文字
				tabList: [
					{ title: '按每件货物填写' },
					{ title: '按每票货件填写' }
				],
				selectNumber: 0,
				totalInfo: {},
				volumeList: [{
					packageType: 0,
					weightUnit: 'KG',
					volumeUnit: 'CM',
					quantity: 1,
					weight: '',
					length: '',
					width: '',
					height: '',
					palletType: '4',
					openFlag: true,
				}],
				originTotalInfo: {
					quantity: '',
					volume: '',
					weight: '',
					volumeUnit: 'CBM',
					weightUnit: 'KG'
				}
			};
		},
		computed: {
			// 计算属性
		},
		watch: {
			// 监测变化
			placeholder: {
				handler(val) {
					// console.log('placeholder', val);
					this.placeholderShow = val
				},
				// deep: true,
				immediate: true,
			},
			panelShow(val) {
				// 获取组件的聚焦状态
				this.$emit('getFocusStatus', val)
			},
		},
		created() {
			// 实例被创建之后执行代码
		},
		mounted() {
			// 页面进入时加载内容
		},
		methods: {
			init(origin, number) {
				if (number) {
					this.selectNumber = number
					if (this.selectNumber === 1) {
						this.originTotalInfo = origin
						let qty = this.originTotalInfo.quantity
						let volume = this.originTotalInfo.volume
						let weight = this.originTotalInfo.weight
						this.text = `${qty} 件 | ${volume} cbm, ${weight} kg`
						this.$emit('next', this.originTotalInfo)
					}
				}
			},
			// 打开下拉列表
			focusInput() {
				this.panelShow = true;
				// 获取选中
				if (this.selectNumber === 1) {
					this.$nextTick(() => {
						this.$refs.TotalShipment.init(this.originTotalInfo)
					})
				} else if (this.selectNumber === 0) {
					this.$nextTick(() => {
						this.$refs.UnitType.init(this.volumeList)
					})
				}
			},
			// 输入框失去焦点
			blurInput() {
				this.placeholderShow = this.placeholder
				if (!this.panelOpen) {
					this.closePanel(1)
				}
			},
			// 关闭下拉列表
			closePanel(val) {
				this.panelShow = false
				if (val == 1) {
					this.$emit('blur')
				}
			},
			clickType(item, index) {
				this.selectNumber = index
			},
			unitSuccess(total, volumes) {
				this.totalInfo = total
				this.volumeList = volumes
				let qty = this.totalInfo.quantity
				let volume = this.totalInfo.volume
				let weight = this.totalInfo.weight
				this.text = `${qty} 件 | ${volume} cbm, ${weight} kg`
				this.$emit('next', this.totalInfo)
				this.closePanel(1)
			},
			totalSuccess(total, origin) {
				this.totalInfo = total
				this.originTotalInfo = origin
				let qty = this.totalInfo.quantity
				let volume = this.totalInfo.volume
				let weight = this.totalInfo.weight
				this.text = `${qty} 件 | ${volume} cbm, ${weight} kg`
				this.$emit('next', this.totalInfo)
				this.closePanel(1)
			}
		}
	};
</script>
<style scoped lang="scss">
	.origin {
		input {
			outline: none;
			border: none;
			height: 28px;
			background: transparent;
			position: relative;
			font-size: 15px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 550;
			color: #333333;
			line-height: 21px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}

		input::-webkit-input-placeholder {
			font-size: 15px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #aaaaaa;
			line-height: 21px;
		}

		.input-error {
			&::-webkit-input-placeholder {
				color: #d83f3f;
			}
		}

		.input-disabled {
			color: #777;
		}

		.by-panel {
			position: absolute;
			left: 0px;
			top: 68px;
			z-index: 10;
			width: 792px;
			height: auto; //360px;
			background: #ffffff;
			box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.08);
			border-radius: 8px;
			border: 1px solid rgba(221, 221, 221, 0.56);

			.load-title {
				height: 32px;
				text-align: left;
				margin: 8px 16px;

				span:nth-of-type(1) {
					color: #e95506;
					margin-right: 10px;
				}

				span:nth-of-type(2) {
					font-size: 14px;
					font-family: D-DINExp, D-DINExp;
					font-weight: bold;
					color: #333333;
				}
			}

			.load-tab {
				width: 248px;
				height: 48px;
				background: #eff1f5;
				border-radius: 8px;
				display: flex;
				align-items: center;

				margin: 16px 16px;
				padding: 4px;
				box-sizing: border-box;

				.tab-class {
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: center;
					width: 120px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 14px;
					color: #333333;
					line-height: 20px;
					text-align: center;
					font-style: normal;
					cursor: pointer;
					transition: all 0.3s;
				}

				.active {

					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #3370ff;
					line-height: 20px;
					text-align: center;
					font-style: normal;
					background: #ffffff;
					border-radius: 6px;
				}
			}
		}
	}
</style>